<template>
  <mj-drop-down-up-transition>
    <div
      v-if="isOpen"
      class="mt-2 absolute"
      :class="`${direction}-0 origin-top-${direction}`"
    >
      <slot />
    </div>
  </mj-drop-down-up-transition>
</template>

<script>

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false,
    },

    direction: {
      type: String,
      required: false,
      default: 'left',
    },
  },
};

</script>

<style lang="scss" scoped>

/* Component Styles */

</style>
